import { ClickType, ClickTypeEnum } from '@/components/TableSearch'
import dayjs from 'dayjs'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type ProjectFieldType = {
  candidates: any[]
  fieldName: string
  fieldTitle: string
  fieldType: string
}
interface State {
  orgTreeOpen: boolean
  orgSearchValue: string
  orgTreeData: any[]
  orgTreeSourceData: any[]
  orgMap: Record<string, any>
  orgSelectKeys?: any[]
  orgSelectNode?: any
  authCodes?: any[] // 云工程权限码
  // 请求权限是否完成
  authed?: boolean
  // 搜索
  templateOptions: any[]
  newProjectTemplateOptions: any[]
  projectSearchKeyword: string
  searchFormData: any // 搜索表单数据，包含关键字，归属状态和过滤条件等

  // 表格
  tableSourceData: any[]
  tableShowData: any[]
  tableParams: any
  rowSelectKeys: any[]

  // 云工程列表
  // projectTableParams: any

  // 列设置
  columnSettingArray: ColumnSettingItem[]
  columnSettingSelectKeys: string[]

  createProjectOpen: boolean
  projectFormMode: 'create' | 'edit' | 'revise' | 'approve' | 'view'
  projectArchiveOpen: boolean
  projectDetailOpen: boolean

  curSelectProjectItem: any
  spaceData?: any

  // 地区选项
  allLocationList: any[] // 所有地区列表
  locationOptions: any[]

  // 工程分类
  engClassCodeItemMap: any,
  // 工程分类选项
  engClassOptions: any[]

  // 业态选项
  allYetaiList: any[] // 所有业态用来工程列表回显
  yetaiOptions: any[]

  // 所有字典值
  allDictData: any[]
  collapsed: boolean

  // 所有项目字段值。包括字段信息和筛选项，列配置信息里没有下拉选项
  allProjectFields: any[]
  // 搜索项目字段值
  searchProjectFields: any[]

  // 全局搜索开关
  globalSearchOpen: boolean

  // 导出开关
  exportOpen: boolean

  /** 地图相关数据 */

  // 地图省份
  provinceName: string
  provinceCode: string
  monthValue: any
  chartYetaiList: any[]
  chartData: any
  chartAmountData: any // 金额数据，项目总投资等等
  chartMapDescData: any // 地图描述数据
  searchClickType: ClickTypeEnum

  // 列设置偏好缓存
  columnPreferencesMap: Record<string, ColumnPreferenceItem[]>

  // 最后一次搜索参数，导出是需要复用
  lastSearchParams: any

  // PDF预览相关状态
  pdfPreviewOpen: boolean // PDF预览弹窗是否打开
  pdfPreviewUrl: string // PDF文件URL
  pdfPrintCount: number // PDF打印次数
  pdfGenerateTime: string // PDF生成时间
  pdfPreviewProjectId: string // 当前预览的项目ID
  projectTransferFormDocumentObj: any // 项目流转单最新信

  // 字典数据
  dictHzdwOptions: any[] // 合作单位，合作单位管理列表的数据，不是字典的数据
  dictMarkOptions: any[] // 标注
  dictProjectSourceOptions: any[] // 项目来源
  dictProjectSourceOptionsCodeMap: any // 项目来源映射
  dictProjectTypeOptions: any[] // 项目类型
  dictProjectTypeOptionsCodeMap: any // 项目类型映射
  dictProjectTypeSonOptions: any[] // 项目子类型
  dictProjectMarkOptionsCodeMap: any // 标注映射
  // dictProjectSubTypeOptionsCodeMap: any // 项目子类型映射
}

interface Actions {
  setOrgTreeDatasetOrgTreeData: (value: State['orgTreeData']) => void
  setSearchValue: (value: State['orgSearchValue']) => void
  resetStore: () => void
  setAuthCodes: (value: State['authCodes']) => void
  // 获取格式化的月份数组
  getMonthValue: () => string[]
  // 获取请求参数
  getEchartQueryParams: () => any
  setColumnPreferences: (key: string, prefs: ColumnPreferenceItem[]) => void
  getColumnPreferences: (key: string) => ColumnPreferenceItem[] | undefined
  setColumnSettings: (payload: { columns: ColumnSettingItem[]; selectedKeys: string[] }) => void
}

export interface ColumnPreferenceItem {
  key: string
  checked: boolean
  fixed?: 'left' | 'right'
}

export interface ColumnSettingItem {
  key: string
  title: string
  origin: 'static' | 'dynamic' | 'extra'
  order: number
  checked: boolean
  fixed?: 'left' | 'right'
  disabled?: boolean
  width?: number
  raw?: Record<string, any>
}

// define the initial state
const initialState: State = {
  projectSearchKeyword: '',
  allProjectFields: [],
  searchProjectFields: [],
  authCodes: [],
  authed: false,
  allYetaiList: [],
  allLocationList: [],
  locationOptions: [],
  yetaiOptions: [],
  engClassOptions: [],
  engClassCodeItemMap: {},
  curSelectProjectItem: null,
  projectArchiveOpen: false,
  tableParams: {
    tenantId: '',
    searchKey: '',
    templateId: '',
    ascription: '',
    isArchived: '',
  },
  createProjectOpen: false,
  projectFormMode: 'create',
  projectDetailOpen: false,
  orgTreeOpen: false,
  orgSearchValue: '',
  orgTreeData: [],
  orgTreeSourceData: [],
  orgMap: {},
  templateOptions: [],
  newProjectTemplateOptions: [],
  tableShowData: [],
  tableSourceData: [],
  rowSelectKeys: [],
  columnSettingArray: [],
  columnSettingSelectKeys: [],
  allDictData: [],
  spaceData: {
    space: '', // 所有空间
    used: '', // 已用空间
  },
  orgSelectKeys: [],
  orgSelectNode: null,
  collapsed: false,
  globalSearchOpen: false,
  exportOpen: false,
  provinceName: '',
  provinceCode: '',
  monthValue: [dayjs().startOf('year'), dayjs().endOf('year')],
  chartYetaiList: [],
  chartData: {
    htResults: [], // 合同
    fwResults: [], // 服务
    yhtResults: [], // 月合同
    dqResults: [], // 地区
    ytResults: [], // 业态
    mapResults: [], // 项目分布
    tzResults: [],  // 合同-项目总投资前10客户
    cafResults: [], // 合同额收费前10客户
    cfcResults: [], // 合同最终收费前10客户
  },
  searchFormData: {},
  chartAmountData: [],
  chartMapDescData: [],
  searchClickType: ClickTypeEnum.collapse,
  columnPreferencesMap: {},
  // PDF预览初始状态
  pdfPreviewOpen: false,
  pdfPreviewUrl: '',
  pdfPrintCount: 0,
  pdfGenerateTime: '',
  pdfPreviewProjectId: '',
  projectTransferFormDocumentObj: {},

  // 字典数据
  dictHzdwOptions: [],
  dictMarkOptions: [],
  dictProjectSourceOptions: [],
  dictProjectTypeOptions: [],
  dictProjectTypeSonOptions: [],
  dictProjectTypeOptionsCodeMap: {},
  dictProjectSourceOptionsCodeMap: {},
  dictProjectMarkOptionsCodeMap: {},
  lastSearchParams: {},
}

const useStore = create<State & Actions>()(
  persist(
    (set, get) => ({
      ...initialState,
      setAuthCodes: v => set({ authCodes: v }),
      setOrgTreeDatasetOrgTreeData: v => set({ orgTreeData: v }),
      setSearchValue: v => set({ orgSearchValue: v }),
      resetStore: () => {
        const map = get().columnPreferencesMap
        const orgKeys = get().orgSelectKeys
        const orgNode = get().orgSelectNode
        set({
          ...initialState,
          columnPreferencesMap: map,
          orgSelectKeys: orgKeys,
          orgSelectNode: orgNode,
        })
      },
      getMonthValue: () => {
        const { monthValue } = get()
        const startMills = monthValue
          ? dayjs(monthValue[0]).startOf('month').format('YYYY-MM-DD')
          : undefined
        const endMills = monthValue
          ? dayjs(monthValue[1]).endOf('month').format('YYYY-MM-DD')
          : undefined
        return [startMills, endMills]
      },
      getEchartQueryParams: () => {
        const { orgSelectKeys, provinceCode } = get()
        const [startMills, endMills] = get().getMonthValue()
        return {
          startDate: startMills,
          endDate: endMills,
          orgId: orgSelectKeys?.at(0),
          province: provinceCode,
        }
      },
      setColumnPreferences: (key, prefs) => {
        const map = get().columnPreferencesMap
        set({
          columnPreferencesMap: {
            ...map,
            [key]: prefs.map(item => ({ ...item })),
          },
        })
      },
      getColumnPreferences: key => {
        return get().columnPreferencesMap?.[key]
      },
      setColumnSettings: ({ columns, selectedKeys }) => {
        set({
          columnSettingArray: columns,
          columnSettingSelectKeys: selectedKeys,
        })
      },
    }),
    {
      name: 'cloud-project-store',
      partialize: state => ({
        columnPreferencesMap: state.columnPreferencesMap,
        orgSelectKeys: state.orgSelectKeys,
        orgSelectNode: state.orgSelectNode,
      }),
    },
  ),
)

export default useStore
